<div class="snackbar-container" (animationend)="animationDone($event)">
    <div class="snackbar" [ngClass]="{'snackbar-success': content?.success, 'snackbar-error': !content?.success}">
        <span>{{ content?.text }} </span>
        <span (click)="close()" style="font-size: 16px; color: #B0B7C3; float: right; cursor: pointer;">
      <fa-icon [icon]="closeIcon"></fa-icon>
    </span>
    </div>
</div>
